import { render, staticRenderFns } from "./DaftarTertunda.vue?vue&type=template&id=b3e6988a&"
import script from "./DaftarTertunda.vue?vue&type=script&lang=js&"
export * from "./DaftarTertunda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports